import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';
import type { I18nOptimoveDescLoader, I18nPushSubscriptionBannerDesc } from './types';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const I18N_OPTIMOVE_DESC_LOADER: DiToken<I18nOptimoveDescLoader<I18nPushSubscriptionBannerDesc | undefined>> =
  new DiToken<I18nOptimoveDescLoader<I18nPushSubscriptionBannerDesc | undefined>>('i18nOptimoveDescLoader', {
    factory: () => () => Promise.resolve(undefined)
  });
